var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('item',{attrs:{"item":_vm.record.data.form,"questions":_vm.questions,"response-sets":_vm.responseSets,"has-multiple-pages":_vm.record.data.form.items.length > 2,"questions-to-fetch":_vm.questionsToFetch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }